module.exports = __webpack_public_path__ + "img/g.c9713f35.jpg";